/**
 * Menu Button definition
 *
 * Uses Fluent UI's MenuButtonTemplate which includes the chevron icon,
 * rather than a custom template, to maintain consistency with Fluent UI.
 */
import { MenuButtonStyles, MenuButtonTemplate } from "@fluentui/web-components";
import { MenuButton } from "./menu-button.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-menu-button>
 */
export const definition = MenuButton.compose({
    name: `${DesignSystem.prefix}-menu-button`,
    template: MenuButtonTemplate,
    styles: MenuButtonStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=menu-button.definition.js.map